import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export const LIST_SECTION = Object.freeze({
  DELIVERY_NOTES: "deliveryNotes",
  WORK_ORDERS: "workOrders",
});

const EMPTY_PREFERENCES = Object.freeze({
  [LIST_SECTION.DELIVERY_NOTES]: null,
  [LIST_SECTION.WORK_ORDERS]: null,
});

const STORAGE_KEY = "formweg-list-preferences";
const FIRST_PAGE = "0";

export function buildRestoredListQuery(queryParams, preferences) {
  if (queryParams.toString() || !preferences) return "";

  const restoredParams = new URLSearchParams();
  Object.entries(preferences).forEach(([key, value]) => {
    const values = Array.isArray(value) ? value : [value];
    values
      .filter((item) => item !== "" && item !== null && item !== undefined)
      .forEach((item) => {
        restoredParams.append(key, String(item));
      });
  });
  restoredParams.set("page", FIRST_PAGE);
  return restoredParams.toString();
}

export const useListPreferencesStore = create(
  persist(
    (set) => ({
      preferences: { ...EMPTY_PREFERENCES },
      remember: (section, preferences) => {
        if (!Object.values(LIST_SECTION).includes(section)) {
          throw new Error(`Unknown list section: ${section}`);
        }
        set((state) => ({
          preferences: {
            ...state.preferences,
            [section]: preferences,
          },
        }));
      },
      reset: () => set({ preferences: { ...EMPTY_PREFERENCES } }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ preferences: state.preferences }),
    },
  ),
);
